import styled from 'styled-components';

export const Shipping = styled.div`
  background: white;
  min-height: 100%;
`
